import React, { useContext, useEffect, useRef, useState } from 'react';

import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';

import { i18n } from '../../translate/i18n';
import api from '../../services/api';
import ConfirmationModal from '../ConfirmationModal';
import TransferTicketModalCustom from '../TransferTicketModalCustom';
import ScheduleModal from '../ScheduleModal';
import toastError from '../../errors/toastError';
import { Can } from '../Can';
import { AuthContext } from '../../context/Auth/AuthContext';

const TicketOptionsMenu = ({ ticket, menuOpen, handleClose, anchorEl }) => {
  const [confirmationOpen, setConfirmationOpen] = useState(false);
  const [transferTicketModalOpen, setTransferTicketModalOpen] = useState(false);
  const [scheduleModalOpen, setScheduleModalOpen] = useState(false);
  const isMounted = useRef(true);
  const { user } = useContext(AuthContext);

  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);

  const handleDeleteTicket = async () => {
    try {
      await api.delete(`/tickets/${ticket.id}`);
      handleClose();
    } catch (err) {
      toastError(err);
    }
  };

  const handleOpenConfirmationModal = e => {
    setConfirmationOpen(true);
  };

  const handleOpenTransferModal = e => {
    setTransferTicketModalOpen(true);
  };

  const handleCloseTransferTicketModal = () => {
    setTransferTicketModalOpen(false);
  };

  const handleOpenScheduleModal = () => {
    setScheduleModalOpen(true);
  };

  const handleCloseScheduleModal = () => {
    setScheduleModalOpen(false);
  };

  // Função para atualizar status do ticket
  const handleUpdateTicketStatus = async (status, userId) => {
    try {
      await api.put(`/tickets/${ticket.id}`, {
        status: status,
        userId: userId || null,
        useIntegration: status === 'closed' ? false : ticket.useIntegration,
        promptId: status === 'closed' ? false : ticket.promptId,
        integrationId: status === 'closed' ? false : ticket.integrationId,
      });
      handleClose();
    } catch (err) {
      toastError(err);
    }
  };

  return (
    <>
      <Menu
        open={menuOpen}
        onClose={handleClose}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <MenuItem onClick={handleOpenScheduleModal}>
          {i18n.t('ticketOptionsMenu.dispatches')}
        </MenuItem>
        <MenuItem onClick={handleOpenTransferModal}>
          {i18n.t('ticketOptionsMenu.transfer')}
        </MenuItem>
        {(() => {
          return user?.profile === 'admin' || user?.profile === 'super';
        })() && (
          <MenuItem onClick={() => handleUpdateTicketStatus('pending', null)}>
            {i18n.t('messagesList.header.buttons.return')}
          </MenuItem>
        )}
        <Can
          role={user.profile}
          perform='ticket-options:deleteTicket'
          yes={() => (
            <MenuItem onClick={handleOpenConfirmationModal}>
              {i18n.t('ticketOptionsMenu.delete')}
            </MenuItem>
          )}
        />
      </Menu>
      <ConfirmationModal
        title={`${i18n.t('ticketOptionsMenu.confirmationModal.title')} #${ticket.protocol}`}
        open={confirmationOpen}
        onClose={setConfirmationOpen}
        onConfirm={handleDeleteTicket}
      >
        {i18n.t('ticketOptionsMenu.confirmationModal.message')}
      </ConfirmationModal>
      <TransferTicketModalCustom
        modalOpen={transferTicketModalOpen}
        onClose={handleCloseTransferTicketModal}
        ticketid={ticket.id}
      />
      <ScheduleModal
        open={scheduleModalOpen}
        onClose={handleCloseScheduleModal}
        aria-labelledby='form-dialog-title'
        contactId={ticket.contactId}
        ticket={ticket}
      />
    </>
  );
};

export default TicketOptionsMenu;
